import { HubOption } from 'dorian-shared/types/branch/HubOption';
import { deepCloneOption, cloneWithNewUuids } from '../hubOptionClone';

let clipboard: HubOption[] = [];
const listeners = new Set<() => void>();

function notifyListeners(): void {
  listeners.forEach((fn) => fn());
}

export function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function copyOptions(options: HubOption[]): void {
  clipboard = options.map(deepCloneOption);
  notifyListeners();
}

export function getClipboard(): HubOption[] {
  return clipboard;
}

export function hasClipboard(): boolean {
  return clipboard.length > 0;
}

export function clearClipboard(): void {
  clipboard = [];
  notifyListeners();
}

export function pasteOptions(): HubOption[] {
  return clipboard.map(cloneWithNewUuids);
}
